module.exports = __webpack_public_path__ + "img/2-en.68691e91.jpg";